module.exports = __webpack_public_path__ + "media/images/application/placeholder/placeholder-16x9-4ab1f0ba235f5552d4266f5545bc347e.jpg";